import TextAutoTruncate from "component/TextAutoTruncate";
import { CSSProperties, memo } from "react";
import { twMerge } from "tailwind-merge";

interface ScheduleCardProps {
  name?: string;
  serviceName?: string;
  staffName?: string;
  onClick?: () => void;
  isHistory?: boolean;
  numOfSections?: number;
  className?: string;
  style?: CSSProperties;
}

export const CARD_HEIGHT = 90;
export const GAP_Y = 10;

const ScheduleCard = (props: ScheduleCardProps) => {
  const {
    name,
    serviceName,
    staffName,
    isHistory,
    numOfSections = 1,
    className,
    style,
    onClick,
  } = props;

  return (
    <div
      className={twMerge(
        "text-[12px] p-[10px] relative overflow-y-visible w-full",
        className
      )}
      style={style}
    >
      <div
        style={{
          backgroundColor: isHistory ? "#666666" : "#ffff00",
          height: numOfSections * CARD_HEIGHT + (numOfSections - 1) * GAP_Y,
        }}
        className="absolute top-0 left-0 cursor-pointer p-[10px] w-full border border-[#e3e3e3] z-10"
        onClick={onClick}
      >
        <p>お客様:</p>

        <TextAutoTruncate className="truncate font-[600]">
          {name}
        </TextAutoTruncate>
        <TextAutoTruncate>{serviceName}</TextAutoTruncate>

          {staffName ? (
            <TextAutoTruncate className="truncate font-[600]">{staffName}</TextAutoTruncate>
          ) : (
            <p className="truncate">未対応</p>
          )}
      </div>
    </div>
  );
};

export default memo(ScheduleCard);
